export default function Wysiwyg({ content }) {
  const parse = require("html-react-parser");

  if (!content?.content) {
      return <></>
  }

  return (
    <section className="block mt-10 lg:mt-24">
      <div className="olafGrid wysiwyg lg:max-w-5xl lg:ml-0 prose prose-base md:prose-xl prose-strong:text-olaf-green-500 prose-headings:text-olaf-green-500 prose-a:text-olaf-green-500 prose-a:text-initial">
        {parse(content?.content)}
      </div>
    </section>
  );
}
